import { Backdrop, CircularProgress } from '@mui/material';
import { useAppSelector } from '@store/hooks';
import { selectIsLoading } from '@store/features/loading';

export default function Loader() {
  const isLoading = useAppSelector(selectIsLoading);

  return (
    <Backdrop
      open={isLoading}
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
